import {
  WritableSignal,
  assertInInjectionContext,
  effect,
  inject
} from '@angular/core';

import { BrowserApiService, LocalStorage } from '../common';

// TODO do better types
export function syncWithLocalStorage(storageKey: string, keysToSignals: Record<string, WritableSignal<any>>): null {
  assertInInjectionContext(syncWithLocalStorage);

  const localStorage = inject(LocalStorage);
  const browser = inject(BrowserApiService);

  if(browser.isServer()) {
    return null;
  }

  const data = localStorage.getItem<Record<string, any>>(storageKey);

  if(data) {
    for(const key in keysToSignals) {
      const value = data[key];

      if(value !== undefined) {
        keysToSignals[key].set(value);
      }
    }
  }

  effect(() => {
    const storageData: Record<string, WritableSignal<any>> = {};

    for(const key in keysToSignals) {
      storageData[key] = keysToSignals[key]();
    }

    localStorage.setItem(storageKey, storageData);
  });

  return null;
}
